import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=0a395dfc&scoped=true"
import script from "./Legal.vue?vue&type=script&lang=js"
export * from "./Legal.vue?vue&type=script&lang=js"
import style0 from "./Legal.vue?vue&type=style&index=0&id=0a395dfc&prod&scoped=true&lang=css"
import style1 from "./Legal.vue?vue&type=style&index=1&id=0a395dfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a395dfc",
  null
  
)

export default component.exports